import * as React from 'react';
import defaultLanguage from 'i18n/defaultLanguage';
import { useTranslation, Trans } from 'react-i18next';

import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const LanguageSection = () => {
  const { i18n } = useTranslation();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const languages = React.useMemo(() => {
    return defaultLanguage.options.map(i => {
      return {
        ...i,
        onChange(i) {
          if (i.code === i18n.language) return;
          i18n.changeLanguage(i.code);
          location.reload();
        }
      };
    });
  }, []);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack  ref={anchorRef} direction="row" spacing={0}  onClick={handleToggle}>
      <Typography sx={{
        color: '#4D4D4D',
        fontSize: 17,
        ml: 1,
        mt: 0.1
      }}
      >
        {/* todo-i18n toolbar.language */}
        <Trans i18nKey="toolbar.language">
          { defaultLanguage.toolbar.language }
        </Trans>

      </Typography>
      <KeyboardArrowDownIcon sx={{ color:'#4D4D4D' }}></KeyboardArrowDownIcon>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {
                      languages.map(i => (<MenuItem key={i.code} onClick={() => i.onChange(i)}>{i.name}</MenuItem>))
                    }
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
    </Stack>
  );
};

export default LanguageSection;
